// extracted by mini-css-extract-plugin
export default {"pathologiesContainer":"PreconfigPathologies_pathologiesContainer__fLsMd","pathologyItem":"PreconfigPathologies_pathologyItem__EoZDq"};